export enum ReliabilityPrematureFailureStatus {
  Open = 1,
  Confirmed = 2,
  Rejected = 3,
  NotPrematureFailure = 4,
}

export const ReliabilityPrematureFailureChoices = [
  { key: "OPEN", value: ReliabilityPrematureFailureStatus.Open },
  { key: "CONFIRMED", value: ReliabilityPrematureFailureStatus.Confirmed },
  { key: "REJECTED", value: ReliabilityPrematureFailureStatus.Rejected },
  { key: "NOT PREMATURE FAILURE", value: ReliabilityPrematureFailureStatus.NotPrematureFailure },
];
